import React, { useState } from "react";
import { TextInput, TouchableOpacity, View } from "react-native";
import styled from "styled-components/native";
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import fbInstance from "../Config/fbInstance";
import AwesomeAlert from 'react-native-awesome-alerts';
import moment from "moment";
import { GetColors } from "../Config/Datas";
import * as Linking from 'expo-linking';
import { AntDesign, FontAwesome } from '@expo/vector-icons';
import { ScrollView } from "react-native-gesture-handler";

const BackView = styled.View`
    background-color: ${GetColors(0)};
    padding-left: 45px;
    padding-right: 45px;
    margin-bottom: 150px;
`;

const GuideText1 = styled.Text`
    font-size: 14px;
    font-weight: 500;
`;

const GuideText2 = styled.Text`
    font-size: 18px;
    font-weight: 600;
`;

const GuideText3 = styled.Text`
    font-size: 15px;
    font-weight: 600;
`;

const GuideText4 = styled.Text`
    font-size: 20px;
    font-weight: 600;
    color: ${GetColors(0)};
`;

const GuideText5 = styled.Text`
    font-size: 18px;
    font-weight: 700;
    color: ${GetColors(5)};
`;


const GuideText6 = styled.Text`
    font-size: 18px;
    font-weight: 500;
`;

const termsText = `Hello, 
everyone! This is the LONGEST TEXT EVER! 
I was inspired by the various other "longest texts ever" on the internet, and I wanted to make my own. So here it is! This is going to be a WORLD RECORD! This is actually my third attempt at doing this. The first time, I didn't save it. The second time, the Neocities editor crashed. Now I'm writing this in Notepad, then copying it into the Neocities editor instead of typing it directly in the Neocities editor to avoid crashing. It sucks that my past two attempts are gone now. Those actually got pretty long. Not the longest, but still pretty long. I hope this one won't get lost somehow. Anyways, let's talk about WAFFLES! I like waffles. Waffles are cool. Waffles is a funny word. There's a Teen Titans Go episode called "Waffles" where the word "Waffles" is said a hundred-something times. It's pretty annoying. There's also a Teen Titans Go episode about Pig Latin. Don't know what Pig Latin is? It's a language where you take all the consonants before the first vowel, move them to the end, and add '-ay' to the end. If the word begins with a vowel, you just add '-way' to the end. For example, "Waffles" becomes "Afflesway". I've been speaking Pig Latin fluently since the fourth grade, so it surprised me when I saw the episode for the first time. I speak Pig Latin with my sister sometimes. It's pretty fun. I like speaking it in public so that everyone around us gets confused. That's never actually happened before, but if it ever does, 'twill be pretty funny. By the way, "'twill" is a word I invented recently, and it's a contraction of "it will". I really hope it gains popularity in the near future, because "'twill" is WAY more fun than saying "it'll". "It'll" is too boring. Nobody likes boring. This is nowhere near being the longest text ever, but eventually it will be! I might still be writing this a decade later, who knows? But right now, it's not very long. But I'll just keep writing until it is the longest! Have you ever heard the song "Dau Dau" by Awesome Scampis? It's an amazing song. Look it up on YouTube! I play that song all the time around my sister! It drives her crazy, and I love it. Another way I like driving my sister crazy is by speaking my own made up language to her. She hates the languages I make! The only language that we both speak besides English is Pig Latin. I think you already knew that. Whatever. I think I'm gonna go for now. Bye! Hi, I'm back now. I'm gonna contribute more to this soon-to-be giant wall of text. I just realised I have a giant stuffed frog on my bed. I forgot his name. I'm pretty sure it was something stupid though. I think it was "FROG" in Morse Code or something. Morse Code is cool. I know a bit of it, but I'm not very good at it. I'm also not very good at French. I barely know anything in French, and my pronunciation probably sucks. But I'm learning it, at least. I'm also learning Esperanto. It's this language that was made up by some guy a long time ago to be the "universal language". A lot of people speak it. I am such a language nerd. Half of this text is probably gonna be about languages. But hey, as long as it's long! Ha, get it? As LONG as it's LONG? I'm so funny, right? No, I'm not. I should probably get some sleep. Goodnight!`;

const SignIn = ({ navigation }) => {
    const fAuth = fbInstance.auth();
    const fDb = fbInstance.firestore();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [vPassword, setVPassword] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [companyBossName, setCompanyBossName] = useState("");
    const [companyBusinessNumber, setCompanyBusinessNumber] = useState("");
    const [companyPhone, setCompanyPhone] = useState("");
    const [companyInchargePerson, setCompanyInchargePerson] = useState("");
    const [isAlert, setIsAlert] = useState([false, false, "국화", true, -1]);
    const [agreement1, setAgreement1] = useState(false);

    const onChangeEmail = t => {
        setEmail(t.nativeEvent.text);
    }

    const onChangePw = text => {
        setPassword(text.nativeEvent.text);
    }
    const onChangeVPw = text => {
        setVPassword(text.nativeEvent.text);
    }
    const onChange11 = text => {
        setCompanyName(text.nativeEvent.text);
    }
    const onChange22 = text => {
        setCompanyBossName(text.nativeEvent.text);
    }
    const onChange33 = text => {
        setCompanyBusinessNumber(text.nativeEvent.text);
    }
    const onChange44 = text => {
        setCompanyInchargePerson(text.nativeEvent.text);
    }
    const onChange55 = text => {
        setCompanyPhone(text.nativeEvent.text);
    }

    const onSignIn = async () => {
        if (!agreement1) {
            setIsAlert([true, false, "개인정보 보호 약관에 동의해주세요.", true, -1]);
            return;
        }

        if (email.length === 0) {
            setIsAlert([true, false, "이메일 주소를 확인해주세요.", true, -1]);
            return;
        }

        let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;
        if (reg.test(email) === false) {
            setIsAlert([true, false, "이메일 형식을 확인해주세요.", true, -1]);
            return;
        }

        if (password !== vPassword) {
            setIsAlert([true, false, "입력하신 비밀번호가 일치하지 않습니다.", true, -1]);
            return;
        }


        if (password.length < 6) {
            setIsAlert([true, false, "6자리 이상의 비밀번호를 설정해주세요.", true, -1]);
            return;
        }


        if (companyName.length === 0 || companyBossName.length === 0 || companyBusinessNumber.length === 0) {
            setIsAlert([true, false, "필수 입력정보를 확인하신 후 다시 시도해주세요.", true, -1]);
            return;
        }


        try {
            setIsAlert([true, true, "회원가입을 진행중입니다.\n잠시만 기다려주세요.", false, -1]);

            const response = await fAuth.createUserWithEmailAndPassword(email, password);
            if (response.user.uid) {
                const user = {
                    uid: response.user.uid,
                    email: email,
                    userCode: 0,
                    companyName: companyName,
                    companyBossName: companyBossName,
                    companyBusinessNumber: companyBusinessNumber,
                    signInDate: moment().format('YYYY/MM/DD')
                }

                fDb.collection('GUsers')
                    .doc(response.user.uid)
                    .set(user);

                // 0623 추가 데이터
                // 홈페이지 주소(homepage), 안치능력(Capacity), 사설/공설(OperationType)
                const baseCompnayInfo = {
                    code1: "0",
                    code2: "0",
                    companyUid: user.uid,
                    email: email,
                    mainPics: [],
                    companyMainPicUrl: "",
                    companyMainPicPath: "",
                    companyName: companyName,
                    homepage: "",
                    capacity: "",
                    operationType: false,
                    companyBossName: companyBossName,
                    companyBusinessNumber: companyBusinessNumber,
                    companyPhone: companyPhone,
                    companyInchargePerson: companyInchargePerson,
                    companyIntro: "",
                    companyAddress: "",
                    comment: "",
                    companyParking: false,
                    confirmed: false,
                    holding: false,
                    roomInfo: [
                        {
                            id: Math.random().toString(),
                            roomName: "",
                            roomSize: "",
                            roomPrice: "",
                            byeTime: "0,0",
                            userHistoryIndex: 0,
                            storeHistoryIndex: 0,
                            RIPName: "",
                            RIPResponsibilityName: "",
                            roomBookState: true,
                            roomBookStart: "",
                            roomBookEnd: "",
                            roomBookUserUid: "",
                            roomBookUserInfo: "",
                            roomState: "",
                            roomSaleRate: "",
                            roomPics: [
                            ]
                        }
                    ]
                };

                fDb.collection('StoreInfo')
                    .doc(response.user.uid)
                    .set(baseCompnayInfo);

                setIsAlert([true, false, "회원가입이 신청되었습니다.\n정보를 입력할 수 있지만 관리자의 승인 후에\n사용자에게 노출됩니다.\n승인여부는 로그인 후 알 수 있습니다.", true, 0]);
            }
        } catch (e) {
            console.log(e);
            setIsAlert([true, false, "회원가입 실패.\n가입정보를 확인해주세요.", true, -1]);
        }
    }

    return (
        <View style={{ width: '100%', flex: 1, alignItems: 'center', backgroundColor: GetColors(0) }}>
            <KeyboardAwareScrollView showsHorizontalScrollIndicator={false} style={{ width: 400, backgroundColor: GetColors(0) }}>
                <BackView>
                    <View style={{ flexDirection: 'row', paddingTop: 3, alignItems: 'center', paddingTop: 20 }}>
                        <GuideText5>국화</GuideText5>
                        <GuideText1>와 함께 해주셔서 감사합니다.</GuideText1>
                    </View>
                    <View style={{ flexDirection: 'row', paddingTop: 3, alignItems: 'center', paddingTop: 20 }}>
                        <GuideText5>국화</GuideText5>
                        <GuideText1>와 제휴를 하시려면,</GuideText1>
                    </View>
                    <GuideText1>아래 내용을 작성해서 신청해주세요.</GuideText1>
                    <GuideText1>신청결과는 영업일 기준 1-3일이 소요됩니다.</GuideText1>
                    <GuideText2 style={{ paddingTop: 30 }}>이메일</GuideText2>
                    <TextInput style={{
                        paddingLeft: 15,
                        marginTop: 5,
                        height: 40,
                        borderRadius: 5,
                        borderColor: GetColors(17),
                        borderWidth: 0.5
                    }}
                        keyboardType="email-address"
                        placeholder="gukhwa@gmail.com"
                        onChange={onChangeEmail}></TextInput>
                    <GuideText2 style={{ paddingTop: 20 }}>비밀번호</GuideText2>
                    <TextInput style={{
                        paddingLeft: 15,
                        marginTop: 5,
                        height: 40,
                        borderRadius: 5,
                        borderColor: GetColors(17),
                        borderWidth: 0.5
                    }}
                        keyboardType="default"
                        secureTextEntry={true}
                        placeholder="영문, 숫자 조합 최소 6자 이상"
                        onChange={onChangePw}></TextInput>
                    <GuideText2 style={{ paddingTop: 20 }}>비밀번호 확인</GuideText2>
                    <TextInput style={{
                        paddingLeft: 15,
                        marginTop: 5,
                        height: 40,
                        borderRadius: 5,
                        borderColor: GetColors(17),
                        borderWidth: 0.5
                    }}
                        keyboardType="default"
                        secureTextEntry={true}
                        placeholder="비밀번호를 다시한번 입력해주세요."
                        onChange={onChangeVPw}></TextInput>
                    <GuideText2 style={{ paddingTop: 20 }}>사업체명</GuideText2>
                    <TextInput style={{
                        paddingLeft: 15,
                        marginTop: 5,
                        height: 40,
                        borderRadius: 5,
                        borderColor: GetColors(17),
                        borderWidth: 0.5
                    }}
                        placeholder="국화 장례식장"
                        onChange={onChange11}></TextInput>
                    <GuideText2 style={{ paddingTop: 20 }}>대표자 성함</GuideText2>
                    <TextInput style={{
                        paddingLeft: 15,
                        marginTop: 5,
                        height: 40,
                        borderRadius: 5,
                        borderColor: GetColors(17),
                        borderWidth: 0.5
                    }}
                        placeholder="홍길동"
                        onChange={onChange22}></TextInput>
                    <GuideText2 style={{ paddingTop: 20 }}>사업자등록번호</GuideText2>
                    <TextInput style={{
                        paddingLeft: 15,
                        marginTop: 5,
                        height: 40,
                        borderRadius: 5,
                        borderColor: GetColors(17),
                        borderWidth: 0.5
                    }}
                        keyboardType="number-pad"
                        placeholder="사업자 등록번호를 - 없이 입력해 주세요."
                        onChange={onChange33}></TextInput>
                    <GuideText2 style={{ paddingTop: 20 }}>담당자성함</GuideText2>
                    <TextInput style={{
                        paddingLeft: 15,
                        marginTop: 5,
                        height: 40,
                        borderRadius: 5,
                        borderColor: GetColors(17),
                        borderWidth: 0.5
                    }}
                        placeholder="담당자(신청자) 이름을 입력해주세요."
                        onChange={onChange44}></TextInput>
                    <GuideText2 style={{ paddingTop: 20 }}>사업체 대표번호</GuideText2>
                    <TextInput style={{
                        paddingLeft: 15,
                        marginTop: 5,
                        height: 40,
                        borderRadius: 5,
                        borderColor: GetColors(17),
                        borderWidth: 0.5
                    }}
                        keyboardType="number-pad"
                        placeholder="02 1234 1234 확인용으로 사용됩니다."
                        onChange={onChange55}></TextInput>

                    <GuideText3 style={{ paddingTop: 20 }}>개인정보 보호약관</GuideText3>
                    {/* <ScrollView style={{ borderRadius: 5, borderWidth: 0.5, borderColor: 'black', height: 150, padding: 10}}>
                        <GuideText3>{termsText}</GuideText3>
                    </ScrollView> */}
                    <TouchableOpacity onPress={() => Linking.openURL(`https://theonplatform.imweb.me/terms`)}>
                        <GuideText3 style={{ color: GetColors(5) }}>https://theonplatform.imweb.me/terms</GuideText3>
                    </TouchableOpacity>
                    <TouchableOpacity
                        style={{ marginTop: 10, flexDirection: 'row', height: 30, alignItems: 'center' }}
                        onPress={() => setAgreement1(!agreement1)}>
                        {agreement1 ?
                            <AntDesign name="checkcircleo" size={25} color={GetColors(5)} />
                            :
                            <FontAwesome name="circle-thin" size={29} color='grey' />
                        }
                        <GuideText6 style={{ color: agreement1 ? GetColors(5) : 'grey' }}>  개인정보 보호 약관 동의</GuideText6>
                    </TouchableOpacity>
                    <TouchableOpacity style={{ marginTop: 30, justifyContent: 'center', alignItems: 'center', height: 45, borderRadius: 30, backgroundColor: GetColors(5) }}
                        onPress={onSignIn}>
                        <GuideText4>회원가입</GuideText4>
                    </TouchableOpacity>
                </BackView>
                <AwesomeAlert
                    show={isAlert[0]}
                    showProgress={isAlert[1]}
                    title="국화"
                    message={isAlert[2]}
                    closeOnTouchOutside={false}
                    closeOnHardwareBackPress={false}
                    showCancelButton={false}
                    showConfirmButton={isAlert[3]}
                    cancelText=""
                    confirmText=" 확인 "
                    confirmButtonColor="#000000"
                    onCancelPressed={() => {
                    }}
                    onConfirmPressed={() => {
                        if (isAlert[4] == 0) {
                            navigation.goBack();
                            navigation.goBack();
                        }
                        setIsAlert([false, false, "국화", true, -1]);
                    }}
                />
            </KeyboardAwareScrollView>
        </View>
    )
}

export default SignIn;
